import React from 'react';
import styled from 'styled-components';
import { DEVICES } from '../../const';

const Container = styled.div`
  background-color: #fff;
`;

const Inner = styled.div`
  margin: auto;

  @media ${DEVICES.mobile} {
    display: block;
    padding: 36px 0;
    text-align: center;
  }

  @media ${DEVICES.tablet} {
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    padding: 100px 0;
    text-align: left;
  }

  @media ${DEVICES.large} {
    display: flex;
    max-width: 1200px;
    align-items: center;
  }
`;

const Left = styled.div`
  padding: 2rem;
  @media ${DEVICES.mobile} {
  }

  @media ${DEVICES.tablet} {
    width: 50%;
  }

  @media ${DEVICES.large} {
    width: 50%;
  }
`;

const LeftTitle = styled.div`
  font-weight: 700;
  margin-top: 1rem;
  line-height: 1.5;

  @media ${DEVICES.mobile} {
    font-size: 1.8rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 2.2rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 2.5rem;
  }
`;

const LeftDescription = styled.div`
  margin-top: 2rem;
  @media ${DEVICES.mobile} {
    font-size: 1rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 1rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 1rem;
  }
`;

const Right = styled.div`
  padding: 2rem;
  @media ${DEVICES.mobile} {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media ${DEVICES.tablet} {
    width: 50%;
  }

  @media ${DEVICES.large} {
    width: 50%;
  }
`;

const RightImg = styled.img`
  width: 100%;
  border-radius: 20px;
  filter: drop-shadow(0px 4px 16px rgba(0, 0, 0, 0.25));
`;

export default function AboutFirstBanner() {
  return (
    <Container>
      <Inner>
        <Right>
          <RightImg src="https://kangaroo-edu-main.s3.ap-northeast-2.amazonaws.com/landing-page/about/first.jpg" />
        </Right>
        <Left>
          <LeftTitle>
            디지털 빌런으로부터, <br />
            아이들을 해방시키고 싶었습니다.
          </LeftTitle>
          <LeftDescription>
            디지털 환경으로부터 벗어나 <br />
            운동을 처음 시작하는 아이들에게 가장 <br />
            필요한 곳이 되어주고 싶었습니다.
          </LeftDescription>
        </Left>
      </Inner>
    </Container>
  )
}
